import { Logger, LoggerService } from "@Shared/logger";
import { Auth0Service } from "@Modules/auth_module";
import { PipelineContext, PipelineStep } from "@Modules/pipeline_module/_base";
import { Bus } from "@Modules/event_module";
import { APP_EVENTS } from "@Core";

import { ScreenManager } from "@Modules/ui_module";
import { OptionsModule } from "@Modules/options_module";


import { CheckAuthStatusStep } from "./check-auth-status.step";

export class LoginStep implements PipelineStep {
    private auth0Service: Auth0Service;

    private email: string;
    private password: string;

    constructor(email: string, password: string) {
        this.email = email;
        this.password = password;

    }

    private Logger: Logger = LoggerService.createLogger("LoginStep");
    async execute(context: PipelineContext): Promise<PipelineStep | null> {
        this.Logger.trace("Executing....", context);
        this.auth0Service = Auth0Service.Instance;
        const screenManager = ScreenManager.Instance;
        const options = OptionsModule.Options.ui.screens.login;
        const loginRes = await this.auth0Service.login(this.email, this.password);
        context.onLogin = {page: location.href, result: loginRes};
        if (loginRes.success) {
            this.Logger.trace("Login successful");

            screenManager.CurrentScreen.Alert.success(options.formOptions.successMessage || "Login Successful");
            return new CheckAuthStatusStep();
            
        } else {
            screenManager.CurrentScreen.Alert.error(loginRes.error.message);
            screenManager.CurrentScreen.Form.enable();
            return null;
        }




    }
}